import {Injectable} from '@angular/core';
import {UserService} from "./user.service";
import {BaseService} from "./_base.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, throwError } from 'rxjs';
import { DocumentOwner } from '../models/document-owner.model';

@Injectable()
export class DocumentOwnerService extends BaseService{

  constructor(http: HttpClient, userService: UserService) {
    super()
  }
  
  index(documentId: number, documentType: string) {
    return this.http
      .get<DocumentOwner[]>(
        `${this.apiURL}/document_owners`,
        this.getParams({ document_id: documentId, document_type: documentType })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error(error);
          return throwError(() => error);
        }),
      );
  }

  destroy(id: number){
    return this.http.delete(`${this.apiURL}/document_owners/${id}`, this.getParams());
  }
}
